// @flow
import React from "react";
import { useSelector } from "react-redux";

import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
} from "../configuracoes";
import SelecaoJanelaMovel from "../configuracoes/janela/SelecaoJanelaMovel";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";

export const processarPeriodo = comGeradorDePeriodo((state, medidas) => {
  const edicaoMedida = getEdicaoMedida(state);
  const dataBase = getDataBaseSelecionadaAsString(state);
  const modoSeries = isModoSeries(state);

  if (modoSeries) {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      janelaMovel: edicaoMedida.janelaMovel,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  } else {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      periodicidade: edicaoMedida.periodicidade,
      ajusteDias: edicaoMedida.ajusteDias,
      dataBase: dataBase,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
});

const Periodo = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <div className="ConfiguracaoMedida">
        <SelecaoJanelaMovel />
      </div>
    );
  } else {
    return (
      <>
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <div className="ConfiguracaoMedida">
          <div className="ConfiguracaoMedida__box">
            <SelecaoPeriodicidade />
          </div>
          <div className="ConfiguracaoMedida__box">
            <SelecaoAjusteDias />
          </div>
        </div>
        <SelecaoCasasDecimais />
      </>
    );
  }
};

export default Periodo;
